import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HamburgerMenu } from './HamburgerMenu';
import { NavbarDrawer } from './NavbarDrawer';
import { BrandMark } from '../icons/Logo';

const navItems = [
  { path: '/', label: 'Home' },
  { path: '/publications', label: 'Publications' },
  { path: '/articles', label: 'Articles' },
  { path: '/certifications', label: 'Certifications' },
];

export const Navbar: React.FC = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isMobileView, setIsMobileView] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    const checkScreenSize = () => {
      setIsMobileView(window.innerWidth <= 768);
    };

    checkScreenSize();
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };

  return (
    <>
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        zIndex: 1002,
        display: 'flex',
        justifyContent: 'center',
        pointerEvents: 'none',
        paddingTop: scrolled ? '16px' : '24px',
        transition: 'all 0.4s cubic-bezier(0.16, 1, 0.3, 1)'
      }}>
        <nav
          style={{
            pointerEvents: 'auto',
            background: scrolled ? 'rgba(16, 14, 13, 0.8)' : 'rgba(16, 14, 13, 0.38)',
            backdropFilter: 'blur(20px)',
            WebkitBackdropFilter: 'blur(20px)',
            border: `1px solid ${scrolled ? 'rgba(196, 149, 106, 0.14)' : 'rgba(245, 245, 245, 0.04)'}`,
            padding: isMobileView ? '4px 16px' : '6px 28px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: isMobileView ? '92%' : '85%',
            maxWidth: '1200px',
            borderRadius: '100px',
            boxShadow: scrolled ? '0 10px 36px rgba(0, 0, 0, 0.34)' : 'none',
            transition: 'all 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
            zIndex: 1003
          }}
        >
          {/* Logo Section */}
          <Link to="/" style={{ textDecoration: "none" }} onClick={closeDrawer}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                cursor: 'pointer',
                transition: 'opacity 0.3s ease',
              }}
              onMouseEnter={(e) => (e.currentTarget.style.opacity = '0.7')}
              onMouseLeave={(e) => (e.currentTarget.style.opacity = '1')}
            >
              <BrandMark size={36} />
            </div>
          </Link>

          {/* Desktop Navigation Links */}
          {!isMobileView && (
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
            }}>
              {navItems.map((item) => {
                const isActive = location.pathname === item.path;
                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    style={{
                      textDecoration: 'none',
                      color: isActive ? '#F5F5F5' : '#737373',
                      fontSize: '13px',
                      fontWeight: isActive ? 500 : 400,
                      fontFamily: "'Inter', sans-serif",
                      letterSpacing: '0.01em',
                      padding: '8px 16px',
                      borderRadius: '100px',
                      transition: 'all 0.25s ease',
                      background: isActive ? 'rgba(196, 149, 106, 0.08)' : 'transparent',
                    }}
                    onMouseEnter={(e) => {
                      if (!isActive) {
                        e.currentTarget.style.color = '#A3A3A3';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!isActive) {
                        e.currentTarget.style.color = '#737373';
                      }
                    }}
                  >
                    {item.label}
                  </Link>
                );
              })}
            </div>
          )}

          {/* Right Section */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '16px',
            zIndex: 1001
          }}>
            <a
              href="https://www.linkedin.com/newsletters/7023338910793523200/"
              target="_blank"
              rel="noopener noreferrer"
              onClick={e => e.stopPropagation()}
              style={{
                display: isMobileView ? 'none' : 'flex',
                alignItems: 'center',
                gap: '5px',
                color: '#C4956A',
                textDecoration: 'none',
                fontSize: '13px',
                fontWeight: 400,
                fontFamily: "'Inter', sans-serif",
                letterSpacing: '0.01em',
                transition: 'color 0.25s ease',
                whiteSpace: 'nowrap',
                padding: '8px 12px',
              }}
              onMouseEnter={e => { e.currentTarget.style.color = '#D4A87A'; }}
              onMouseLeave={e => { e.currentTarget.style.color = '#C4956A'; }}
            >
              Newsletter
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="7" y1="17" x2="17" y2="7" /><polyline points="7 7 17 7 17 17" />
              </svg>
            </a>
            {isMobileView && (
              <div style={{ cursor: 'pointer' }}>
                <HamburgerMenu isOpen={isDrawerOpen} onClick={toggleDrawer} />
              </div>
            )}
          </div>
        </nav>
      </div>

      <NavbarDrawer isOpen={isDrawerOpen} onClose={closeDrawer} />
    </>
  );
};
